import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ForgotPassword } from "../../redux/actions/userActions";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import AuthShell from "../auth/AuthShell";
import Spinner from "../common/Spinner";

const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [sentToEmail, setSentToEmail] = useState("");
  const dispatch = useDispatch();
  const [formState, setFormState] = useState({ values: {} });

  const handleChange = (event) => {
    setFormState((fs) => ({
      ...fs,
      values: { ...fs.values, [event.target.name]: event.target.value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email } = formState.values;
    if (!email) return;
    setLoading(true);
    dispatch(ForgotPassword(email)).then((response) => {
      setLoading(false);
      if (response?.success === 1) setSentToEmail(email);
    });
  };

  return (
    <>
      <AuthShell
        title="Forgot password?"
        subtitle="Enter your email and we'll send you a link to reset your password."
        footer={
          <Typography variant="body2" align="center" sx={{ color: "text.secondary" }}>
            Remembered it?{" "}
            <Link component={RouterLink} to="/login" sx={{ fontWeight: 700 }}>
              Go back to sign in
            </Link>
          </Typography>
        }
      >
        {sentToEmail ? (
          <Stack spacing={2.5}>
            <Alert severity="success" variant="outlined">
              <AlertTitle>Reset link sent</AlertTitle>
              We've sent a password reset link to <strong>{sentToEmail}</strong>. Check your inbox (and your spam folder) and follow the link to set a new password.
            </Alert>
            <Button
              type="button"
              variant="outlined"
              size="large"
              fullWidth
              onClick={() => {
                setSentToEmail("");
                setFormState({ values: {} });
              }}
            >
              Send to a different email
            </Button>
          </Stack>
        ) : (
          <form onSubmit={handleSubmit} autoComplete="off" noValidate>
            <Stack spacing={2.5}>
              <TextField
                label="Email"
                type="email"
                name="email"
                required
                fullWidth
                autoFocus
                autoComplete="email"
                value={formState.values.email || ""}
                onChange={handleChange}
              />

              <Button type="submit" variant="contained" size="large" fullWidth disabled={loading}>
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </Stack>
          </form>
        )}
      </AuthShell>

      {loading && <Spinner fullscreen label="Sending reset link…" />}
    </>
  );
};

export default ForgotPasswordPage;
